import { SVGProps } from "react"

type Props = SVGProps<SVGSVGElement> & {
  height?: number
}

export const IconLogo = ({ height = 24 }: Props) => (
  <svg
    height={height}
    viewBox="0 0 513 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4604_110162)">
      <path
        d="M15.5038 28.3279V46.557C15.5038 50.0892 17.7762 52.1393 21.5307 52.1393C23.3339 52.1393 25.2111 51.6947 26.5697 50.929V58.3145C24.2972 59.3766 21.2096 60.0435 18.3444 60.0435C10.292 60.0435 5.52475 55.5233 5.52475 47.8414V28.3279H0.140015V21.4612H6.16696V8.81445H16.1213V11.9761C16.1213 16.7927 12.515 20.2014 6.46337 21.313V21.4612H27.2613V28.3279H15.5038Z"
        fill="black"
      />
      <path
        d="M61.0268 21.9298L58.1616 30.822C56.6548 29.9822 54.7776 29.4635 52.8756 29.4635C47.071 29.4635 43.6129 34.206 43.6129 42.209V59.3265H33.6586V21.4852H43.6129V37.0959H43.7611C43.7611 26.7711 48.059 20.7441 55.2222 20.7441C57.3958 20.7441 59.5201 21.1888 61.0268 21.9545V21.9298Z"
        fill="black"
      />
      <path
        d="M101.733 21.4607V59.3021H91.7788V46.2602H91.6306C91.6306 54.9301 86.5916 60.0431 78.144 60.0431C68.659 60.0431 63.0767 52.7317 63.0767 40.3814C63.0767 28.0311 68.659 20.7197 78.144 20.7197C86.5916 20.7197 91.6306 25.8327 91.6306 34.4286H91.7788V21.4607H101.733ZM92.3222 40.3814C92.3222 33.3664 88.79 28.5498 82.7383 28.5498C76.6867 28.5498 73.1792 32.9959 73.1792 40.3814C73.1792 47.7669 76.7114 52.1389 82.7383 52.1389C88.7653 52.1389 92.3222 47.3223 92.3222 40.3814Z"
        fill="black"
      />
      <path
        d="M109.513 40.3814C109.513 28.0311 116.824 20.7197 129.027 20.7197C139.351 20.7197 146.07 26.1539 147.577 35.4907H137.771C136.486 31.1187 133.473 28.5498 129.027 28.5498C123.148 28.5498 119.69 32.9959 119.69 40.3814C119.69 47.7669 123.148 52.1389 129.027 52.1389C133.695 52.1389 136.783 49.4218 137.919 44.7534H147.725C146.292 54.4855 139.574 60.0431 129.027 60.0431C116.824 60.0431 109.513 52.7317 109.513 40.3814Z"
        fill="black"
      />
      <path
        d="M190.088 41.5176H162.497C162.868 48.4585 166.202 52.5094 171.538 52.5094C176.206 52.5094 179.442 49.9405 180.43 45.7908H190.088C188.729 54.7572 181.788 60.0431 171.538 60.0431C159.78 60.0431 152.839 52.7317 152.839 40.3814C152.839 28.0311 159.78 20.7197 171.538 20.7197C183.295 20.7197 190.088 27.957 190.088 40.3814V41.5176ZM162.571 38.1336H180.356C179.763 31.8103 176.502 28.1793 171.538 28.1793C166.573 28.1793 163.238 31.7856 162.571 38.1336Z"
        fill="black"
      />
      <path
        d="M226.175 15.4338V21.4608H238.08V28.3275H226.693V59.3021H216.739V28.3275H211.008V21.4608H225.779V21.3126C219.752 20.1763 216.22 16.7923 216.22 11.9757C216.22 4.73845 221.728 0.514648 230.991 0.514648C234.227 0.514648 237.463 1.18156 240.032 2.39189L238.747 9.85148C237.24 8.93755 235.363 8.41884 233.387 8.41884C228.645 8.41884 226.15 11.0618 226.15 15.4338H226.175Z"
        fill="#739987"
      />
      <path
        d="M240.649 40.3814C240.649 28.0311 248.034 20.7197 260.385 20.7197C272.735 20.7197 280.046 28.0311 280.046 40.3814C280.046 52.7317 272.735 60.0431 260.385 60.0431C248.034 60.0431 240.649 52.7317 240.649 40.3814ZM269.969 40.3814C269.969 32.9959 266.436 28.5498 260.409 28.5498C254.382 28.5498 250.826 32.9959 250.826 40.3814C250.826 47.7669 254.358 52.1389 260.409 52.1389C266.461 52.1389 269.969 47.7669 269.969 40.3814Z"
        fill="#739987"
      />
      <path
        d="M315.196 21.9298L312.331 30.822C310.824 29.9822 308.947 29.4635 307.045 29.4635C301.24 29.4635 297.782 34.206 297.782 42.209V59.3265H287.828V21.4852H297.782V37.0959H297.93C297.93 26.7711 302.228 20.7441 309.391 20.7441C311.565 20.7441 313.689 21.1888 315.196 21.9545V21.9298Z"
        fill="#739987"
      />
      <path
        d="M371.488 21.4607V59.7467C371.488 70.8125 364.399 77.3829 352.493 77.3829C342.242 77.3829 335.301 72.344 333.943 63.8223L343.354 62.3896C343.947 66.8357 347.429 69.4787 352.468 69.4787C358.125 69.4787 361.509 66.0947 361.509 60.3642V45.8896H361.361C361.361 54.4855 356.322 59.5985 347.874 59.5985C338.389 59.5985 332.807 52.3612 332.807 40.1591C332.807 27.957 338.389 20.7197 347.874 20.7197C356.322 20.7197 361.361 25.8327 361.361 34.4286H361.509V21.4607H371.463H371.488ZM362.077 40.1591C362.077 33.2923 358.545 28.5498 352.518 28.5498C346.491 28.5498 342.959 32.9218 342.959 40.1591C342.959 47.3964 346.491 51.6943 352.518 51.6943C358.545 51.6943 362.077 47.0259 362.077 40.1591Z"
        fill="black"
      />
      <path
        d="M379.27 40.3814C379.27 28.0311 386.656 20.7197 399.006 20.7197C411.357 20.7197 418.668 28.0311 418.668 40.3814C418.668 52.7317 411.357 60.0431 399.006 60.0431C386.656 60.0431 379.27 52.7317 379.27 40.3814ZM408.59 40.3814C408.59 32.9959 405.058 28.5498 399.031 28.5498C393.004 28.5498 389.472 32.9959 389.472 40.3814C389.472 47.7669 393.004 52.1389 399.031 52.1389C405.058 52.1389 408.59 47.7669 408.59 40.3814Z"
        fill="black"
      />
      <path
        d="M408.59 40.3814C408.59 28.0311 415.976 20.7197 428.326 20.7197C440.676 20.7197 447.988 28.0311 447.988 40.3814C447.988 52.7317 440.676 60.0431 428.326 60.0431C415.976 60.0431 408.59 52.7317 408.59 40.3814ZM437.91 40.3814C437.91 32.9959 434.377 28.5498 428.351 28.5498C422.324 28.5498 418.791 32.9959 418.791 40.3814C418.791 47.7669 422.324 52.1389 428.351 52.1389C434.377 52.1389 437.91 47.7669 437.91 40.3814Z"
        fill="#739987"
      />
      <path
        d="M492.546 1.28027V59.302H482.592V46.2601H482.443C482.443 54.93 477.405 60.043 468.957 60.043C459.472 60.043 453.89 52.7316 453.89 40.3813C453.89 28.031 459.472 20.7196 468.957 20.7196C477.405 20.7196 482.443 25.8327 482.443 34.4285H482.592V1.28027H492.546ZM483.135 40.406C483.135 33.3911 479.603 28.5744 473.576 28.5744C467.549 28.5744 464.017 33.0205 464.017 40.406C464.017 47.7915 467.549 52.1635 473.576 52.1635C479.603 52.1635 483.135 47.3469 483.135 40.406Z"
        fill="black"
      />
      <path
        d="M512.824 48.6807V59.3019H501.759V48.6807H512.824Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4604_110162">
        <rect
          width="512.686"
          height="76.8683"
          fill="white"
          transform="translate(0.139832 0.514648)"
        />
      </clipPath>
    </defs>
  </svg>
)
